<template>
  <div class="home wp75">
    <!-- 热点要闻 -->
    <div class="hot">
      <div class="hot-content">
        <div class="hot-center">
          <div class="hot-center-left">
            <div class="left-title">
              {{ currentItem.title }}
            </div>
            <div class="detail-little-title blue-text">
              <p>{{ currentItem.createTime }}</p>
              <p>来源：{{ currentItem.source ? currentItem.source : '-' }}</p>
              <GsShare
                variant="link"
                button-text="分享链接"
                :path="'/interviews/' + currentItem.id"
                :id="currentItem.id"
                :title="currentItem.title"
                :summary="currentItem.content"
              />
            </div>
            <div class="mt10 content-new color6" style="line-height: 30px" v-html="currentItem.content"></div>
            <el-divider />
            <div style="text-indent: 2rem" class="color9">
              {{ currentItem.rangeTypeName }}
              <p class="color9">
                {{ currentItem.areaName }}
              </p>
            </div>
          </div>
          <div class="hot-center-right">
              <twentyFourNew/>
              <userDetail class="mt20" />
              
          </div>
        </div>
        <!-- <div class="mt20 mb10 fs18 fw700 blue-text">
          最新发表文章
        </div>
        <el-table
          :data="dataList"
          style="width: 100%"
          border
          class="table-content"
          row-class-name="hand-cursor"
        >
          <el-table-column
            prop="title"
            label="文章标题"
            min-width="100"
            header-align="center"
            align="left"
            show-overflow-tooltip
          />
          <el-table-column
            prop="name"
            label="媒体平台"
            min-width="100"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template #default="scope">
              {{ transFormEnum(mediaPlatformList, scope.row.mediaPlatform) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="url"
            label="网站链接"
            min-width="100"
            header-align="center"
            align="center"
            show-overflow-tooltip
          />
        </el-table> -->
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "@/views/Home/components/carousel/index.vue";
import carousel1 from "@/views/Home/components/carousel/index1";
import Banner from "@/views/Home/components/Banner";
import newsDetail from "@/components/NewsDetail/index.vue";
import userDetail from "@/components/UserDetail";
import Interview from "@/components/Interview";
import twentyFourNew from "@/components/24HNew";
import LiveInfo from "@/components/LiveInfo";
import ZcFileInfo from "@/components/ZcFileInfo";
import { getNewsList,interviewNameDetail, articleInfoList} from "@/api/api";
import {enumType} from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import GsShare from '@/components/GsShare/index.vue'
import { routeId } from '@/router/paths'

export default {
  name: 'UserDetailName',
  data() {
    return {
      title: (this.$route.meta && this.$route.meta.title) || '',
      carouselImages: [],
      twentyFourNewList:[],
      hostNewList:[],
      newsDetailData:[],
      newsDetailData2:[],
      userDetailData:[],
      currentItem: {},
      dataList: [],
      mediaPlatformList: [],
      prodUrl:"https://shujuzichan.com/xwzx",
    };
  },
  components: {
    twentyFourNew,
    carousel,
    carousel1,
    Banner,
    newsDetail,
    LiveInfo,
    userDetail,
    Interview,
    ZcFileInfo,
    GsShare,
  },
  computed: {
    transFormEnum () {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  created() {
    this.getSyLbNewList();
    // this.getHostNewList();
    this.getTwentyFourNewList()
    this.articleInfo()
    this.getData('sys_media_platform')
    // this.getNewList();
    // this.getUserData();
  },
  watch: {
    '$route.params.id': {
      deep: true,
      immediate: true,
      handler() {
        const id = routeId(this.$route)
        if(id) this.newsDetail(id)
      }
    }
  },
  methods: {
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_media_platform') {
            this.mediaPlatformList = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    articleInfo() {
      let id = routeId(this.$route)
      articleInfoList(id).then((response) => {
        this.dataList = response.rows
      })
    },
    // x详情数据
    newsDetail(id) {
      interviewNameDetail(id).then(res=>{
        this.currentItem = res.data
      })
    },
    getUserData() {
      const formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=10;
      formData["type"]=3;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.userDetailData = response.rows;
      });
    },

    getNewList () {
      const formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=10;
      formData["type"]=2;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.newsDetailData = response.rows;
      });
      formData["pageNum"]=2;
      getNewsList(formData).then((response) => {
        this.newsDetailData2 = response.rows;
      });
    },
    getSyLbNewList () {
      const formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=5;
      formData["newest"]=0;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.carouselImages = response.rows;
      });
    },
    getHostNewList () {
      const formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=5;
      formData["newest"]=3;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.hostNewList = response.rows;
      });
    },
    getTwentyFourNewList() {
      const formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=10;
      formData["type"]=1;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.twentyFourNewList = response.rows;
      });
    }

  }
};
</script>

<style scoped lang="css">
.hot {
  background: #fff;
  margin-top: 10px;
  height: 100%;
}

.hot-center {
  /* height: 400px; */
  display: flex;
  align-items: center;
  align-items: flex-start;
}
.hot-center-left {
  width: 67%;
  height: 100%;
  padding: 15px;
}
.left-title {
  margin: 20px auto;
  font-size: 20px;
  text-align: center;
}
.detail-little-title {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  font-size: 12px;
  .el-button--text {
    color: #0165FF;
    font-weight: 400;
  }
}
.content-new {
  text-indent: 25px;
  line-height: 30px;
}
.el-divider--horizontal {
  margin: 15px 0;
}
.hot-center-left img {
  width: 100%;
  height: 100%;
}
.hot-center-right {
  width: 33%;
  height: 100%;
  margin-left: 10px;
  overflow: auto;
}

.detail-box img {
  width: 100%;
  height: 150px;
  border-radius: 6px 6px 0 0;
}

</style>